var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'d-none': !_vm.isLoading},attrs:{"id":"overlay-spinner"}},[_c('FadeLoader',{attrs:{"loading":_vm.isLoading,"color":_vm.color,"height":_vm.height,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }